// import React from "react";
// import "./FounderQuote.css";
// import { FaUserTie, FaGlobe, FaHeart } from "react-icons/fa";
// import founderImg from "../../assets/founder.png";

// const credentials = [
//   {
//     icon: <FaUserTie />,
//     text: "25+ years in strategy, transformation and operating model design",
//   },
//   {
//     icon: <FaGlobe />,
//     text: "Partnered with CXOs across 30+ countries",
//   },
//   {
//     icon: <FaHeart />,
//     text: "Believer in clarity, speed and lasting impact",
//   },
// ];

// export default function FounderQuote() {
//   return (
//     <section className="founder">
//       <div className="founder__container">

//         {/* ── LEFT: Founder photo ── */}
//         {/* <div className="founder__image-wrap"> */}
//           <img
//             src={founderImg}
//             alt="Ramesh Bai — Founder & Managing Partner"
//             className="founder__image"
//           />
//         {/* </div> */}

//         {/* ── CENTER: Quote block ── */}
//         <div className="founder__quote-block">
//           <span className="founder__quote-mark">&ldquo;</span>

//           <blockquote className="founder__quote">
//             Transformation is not a project.
//             It is a reinvention of how an enterprise
//             creates, delivers and captures value.
//           </blockquote>

//           <div className="founder__attribution">
//             <p className="founder__name">Ramesh Babu Bairy</p>
//             <p className="founder__role">Founder & Principal Advisor</p>
//           </div>
//         </div>

//         {/* ── RIGHT: Credential points ── */}
//         <div className="founder__credentials">
//           {credentials.map((c, i) => (
//             <div className="founder__credential" key={i}>
//               <span className="founder__cred-icon">{c.icon}</span>
//               <p className="founder__cred-text">{c.text}</p>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// }
























import React from "react";
import "./FounderQuote.css";
import { FaUsers, FaGlobe, FaChartLine, FaHeart, FaMountain  } from "react-icons/fa";
import { TbTargetArrow } from "react-icons/tb";
import { IoSpeedometerOutline } from "react-icons/io5";
import founderImg from "../../assets/founder_img.png";

const credentials = [
  {
    icon: <FaUsers />,
    title: "25+ YEARS OF IMPACT",
    text: "25+ years in strategy, digital transformation & AI-led operating model design.",
  },
  {
    icon: <FaGlobe />,
    title: "GLOBAL TRUST, LOCAL IMPACT",
    text: "Trusted advisor to CXOs across 30+ countries.",
  },
  {
    icon: <FaChartLine />,
    title: "MEASURABLE TRANSFORMATION",
    text: "Delivered measurable impact across industries including retail, manufacturing & healthcare.",
  },
  {
    icon: <IoSpeedometerOutline />,
    title: "CLARITY. SPEED. IMPACT.",
    text: "Driving clarity, speed, and enterprise-scale value realization.",
  },
];

export default function FounderQuote() {
  return (
    <section className="founder">
      <div className="founder__container">

        {/* ── LEFT: Founder photo ── */}
        <img
          src={founderImg}
          alt="Ramesh Babu Bairy — Founder & Principal Advisor"
          className="founder__image"
        />

        {/* ── CENTER: Quote block ── */}
        <div className="founder__quote-block">
          <span className="founder__quote-mark">&ldquo;</span>
          <div className="founder__quote-divider" />

          <blockquote className="founder__quote">
            <span className="founder__quote-dark">AI doesn't<br/> transform companies.</span>{" "}
      
            <span className="founder__quote-dark">Operating models do.</span>{" "}
            <span className="founder__quote-gold">We re-architect <br/> both—together.</span>
          </blockquote>

          <div className="founder__attribution-wrap">
            <div className="founder__attr-line" />
            <div className="founder__attribution">
              <p className="founder__name">RAMESH BABU BAIRY</p>
              <div className="founder__attr-underline" />
              <p className="founder__role-title">FOUNDER & PRINCIPAL ADVISOR,</p>
              <p className="founder__role-company">BAIREES GLOBAL ADVISORY</p>
              <div className="founder__tags">
                <span>Digital Transformation</span>
                <span className="founder__tag-sep">|</span>
                <span>AI-Led Operating Models</span>
                <span className="founder__tag-sep">|</span>
                <span>Enterprise Reinvention</span>
              </div>
            </div>
          </div>

          {/* Mission box */}
          <div className="founder__mission-box">
            <span className="founder__mission-icon"><TbTargetArrow  /></span>
            <p className="founder__mission-text">
              <em>Building BaiRees Global Advisory to redefine how transformation delivers measurable value.</em>
            </p>
          </div>
        </div>

        {/* ── RIGHT: Credential points ── */}
        <div className="founder__credentials">
          {credentials.map((c, i) => (
            <div className="founder__credential" key={i}>
              <span className="founder__cred-icon">{c.icon}</span>
              <div className="founder__cred-body">
                <p className="founder__cred-title">{c.title}</p>
                <p className="founder__cred-text">{c.text}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}